/**
 * Returns the value of `key` if every shape in the array shares the same
 * value, otherwise `undefined` (mixed). Designed for multi-select sidebar
 * controls: a mixed value renders as an empty placeholder; committing any
 * value writes it to all selected shapes via `updateSelectedShape`.
 */
export const getSharedField = <T = unknown>(shapes: object[], key: string): T | undefined => {
  if (!shapes.length) return undefined;
  const first = (shapes[0] as Record<string, unknown>)[key];
  return shapes.every((s) => (s as Record<string, unknown>)[key] === first) ? (first as T) : undefined;
};
